import React, { useState } from 'react';
import { LabeledInput } from '../../Components';
import './Bank.css';
const Bank = () => {
    const [accounteName, setAccountName] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [ifsc, setIfsc] = useState('');
    return (
        <div className="bank_profile">
            <div className="home_head">
                <h2 className="home_heading">Bank Details</h2>
            </div>
            <div className="bank_body">
                <LabeledInput
                    name="account holder"
                    value={accounteName}
                    changeHandler={(e) => {
                        setAccountName(e.target.value);
                    }}
                    label={'Account Holder'}
                />
                <LabeledInput
                    name="account number"
                    value={accountNumber}
                    changeHandler={(e) => {
                        setAccountNumber(e.target.value);
                    }}
                    label={'Account Number'}
                />

                <LabeledInput
                    name="ifsc"
                    value={ifsc}
                    changeHandler={(e) => {
                        setIfsc(e.target.value);
                    }}
                    label={'IFSC'}
                />

                <div className="footer_setting">
                    <button className="btn-orange">Save Changes</button>
                </div>
            </div>
        </div>
    );
};

export default Bank;
